
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";

class Branding extends Component {
    constructor(props) {
        super(props);
        this.state = { isDark: false };
        this._mql = null;
        this._observer = null;
        this._mqlListener = null;
    }

    componentDidMount() {
        if (typeof document === 'undefined') return;

        const hasDarkClass = document.body && document.body.classList && document.body.classList.contains('dark-mode');
        const prefersDark = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        this.setState({ isDark: hasDarkClass || prefersDark });

        if (typeof window !== 'undefined' && window.matchMedia) {
            this._mql = window.matchMedia('(prefers-color-scheme: dark)');
            this._mqlListener = (e) => {
                const nowDark = (document.body && document.body.classList && document.body.classList.contains('dark-mode')) || e.matches;
                this.setState({ isDark: nowDark });
            };
            if (this._mql.addEventListener) this._mql.addEventListener('change', this._mqlListener);
            else if (this._mql.addListener) this._mql.addListener(this._mqlListener);
        }

        if (typeof MutationObserver !== 'undefined' && document.body) {
            this._observer = new MutationObserver(mutations => {
                for (const m of mutations) {
                    if (m.type === 'attributes' && m.attributeName === 'class') {
                        const nowDark = document.body.classList.contains('dark-mode');
                        this.setState({ isDark: nowDark || (this._mql && this._mql.matches) });
                        break;
                    }
                }
            });
            this._observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        }
    }

    componentWillUnmount() {
        if (this._mql) {
            if (this._mql.removeEventListener) this._mql.removeEventListener('change', this._mqlListener);
            else if (this._mql.removeListener) this._mql.removeListener(this._mqlListener);
        }
        if (this._observer) this._observer.disconnect();
    }

    render() {
        const { t, settings } = this.props;
        const defaultLogo = this.state.isDark ? 'img/logo/logo_dark.png' : 'img/logo/logo.png';
        const logoSrc = settings && settings.logoUrl ? settings.logoUrl : defaultLogo;

        return (
            <div className="site-branding">
                <div className="inner">
                    <a
                        className="offcanvas-toggle cats-toggle"
                        href="#shop-categories"
                        data-toggle="offcanvas"
                        title={t("Shop Categories")}
                    >
                        {" "}
                    </a>

                    <a
                        className="offcanvas-toggle menu-toggle"
                        href="#mobile-menu"
                        data-toggle="offcanvas"
                        title={t("Shop Categories")}
                    >
                        {" "}
                    </a>
                    <ExtendedLink className="site-logo d-none d-sm-table-cell" to={`${settings.baseUrl}`}>
                        <img src={logoSrc} alt={t("VIP Shop")} />
                    </ExtendedLink>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ settings }, ownProps) {
    return { settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(Branding));
